NLMK.tableFilter = tableFilter;

$(tableFilter);

function tableFilter() {
    $('.table__wrap').each(function() {
        const $tableWrap = $(this);
        const $btnColumn = $tableWrap.find('.js-checkbox--column .checkbox__input');
        const $btnRow = $tableWrap.find('.js-checkbox--row .checkbox__input');
        const $btnChangeView = $tableWrap.find('.js-change-view');
        const textSave = $btnChangeView.data('save-label');
        const textEdit = $btnChangeView.text();

        if ($btnColumn.length > 0) {
            $btnColumn.off().on('change', function() {
                const itemIndex =
                    $(this)
                        .closest('.table__cell')
                        .index() + 1;
                const $cells = $(this)
                    .closest('.table')
                    .find('.table__cell:nth-child(' + itemIndex + ')');
                const check = $(this).prop('checked');

                if (check) {
                    $cells.removeClass('table__cell--hide');
                } else {
                    $cells.addClass('table__cell--hide');
                }
            });
        }

        if ($btnRow.length > 0) {
            $btnRow.off().on('change', function() {
                const check = $(this).prop('checked');
                const isTableHide = $(this).closest('.table--hide');

                if (isTableHide.length) {
                    return;
                }

                if (check) {
                    $(this)
                        .closest('.table__row')
                        .removeClass('table__row--hide');
                    $(this)
                        .closest('.table__cell')
                        .siblings()
                        .removeClass('hide');
                } else {
                    $(this)
                        .closest('.table__row')
                        .addClass('table__row--hide');
                    $(this)
                        .closest('.table__cell')
                        .siblings()
                        .addClass('hide');
                }
            });
        }

        if ($btnChangeView.length > 0) {
            $btnChangeView.off().on('click', function () {
                const $table = $(this).closest('.table__wrap');

                if ($table.hasClass('table--hide')) {
                    $table.removeClass('table--hide').addClass('table--filter-show');
                    $(this).html(textSave);
                } else {
                    $table.addClass('table--hide').removeClass('table--filter-show');
                    $(this).html(textEdit);
                }
            });
        }
    });
}



// WEBPACK FOOTER //
// ./js/main/module/table-filter.js